import { render, staticRenderFns } from "./TemplateGalleryCardsLayout.vue?vue&type=template&id=38156a0f&scoped=true"
import script from "./TemplateGalleryCardsLayout.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryCardsLayout.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryCardsLayout.vue?vue&type=style&index=0&id=38156a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38156a0f",
  null
  
)

export default component.exports